import React, { useEffect, useState } from 'react';
import Link from 'next/link';
import { useMyOrders } from '../hooks/User';
import { useContext } from 'react';
import appContext from '../Context/appContext';
import orderStatus from '../constants/orderStatus';
import { useDispatch, useSelector } from 'react-redux';
import { setTrackingWidget } from '../redux/slices/otherSlice';

const orderProcessing = [orderStatus.PLACED, orderStatus.ASSIGNED, orderStatus.DISPATCHED, orderStatus.ON_HOLD];

export default function TrackOrder() {
  // const [showTrackingWidget, setShowTrackingWidget] = useState(false)
  const dispatch = useDispatch()
  const showTrackingWidget = useSelector(state => state.other.trackingWidget)

  // const {
  //   state: {
  //     rating: { submitCount }
  //   }
  // } = useContext(appContext)

  const submitCount = useSelector(state => state.rating.submitCount)
  const {
    data: { orders },
    isLoading,
    mutate } = useMyOrders({ offset: 0 })

  useEffect(() => {
    dispatch(setTrackingWidget(!!(orders.length > 0 && orderProcessing.includes(orders[0].order_status_id))))
  }, [isLoading, orders]);

  useEffect(() => {
    mutate()
  }, [submitCount])

  if (!showTrackingWidget) return null
  return (
    <div className="order-tracking">
      <img src="/static/images/trac-order.svg" className="car" alt="Version-change" />
      <span>
        <div className="semi-bold o-title">Track your current order</div>
        <Link prefetch={false} href={`/confirmation/${orders[0]?.order_id}`}>
          <button type="button" className="btn btn-primary btn-sm track-btn">
            Track Order
          </button>
        </Link>

        <button type="button" className="btn text-red bold ml-2 ml-lg-0" onClick={() => dispatch(setTrackingWidget(false))}>
          Dismiss
        </button>
      </span>
    </div>
  );
}
